import { cpf as CPFValidator } from 'cpf-cnpj-validator';
import { isBefore, isValid, parse, startOfMonth } from 'date-fns';
import { unmaskNumber } from 'util/masks';

/**
 * Return field required message
 *
 * @param {string} fieldName
 */
export const requiredMessage = (fieldName: string) =>
  `${fieldName} não pode estar em branco.`;

/**
 * Validate an e-mail address
 *
 * @param {string} email
 * @return {*}  {(string | boolean)}
 */
export const emailValidator = (email: string): string | boolean => {
  const re = /\S+@\S+\.\S+/;

  if (!re.test(email)) {
    return 'E-mail inválido.';
  }

  return true;
};

/**
 * Validate CPF
 *
 * @param {string} cpf
 * @return {*}  {(string | boolean)}
 */
export const cpfValidator = (cpf: string): string | boolean => {
  if (typeof cpf !== 'string') {
    return false;
  }

  const cpfWithoutMask = cpf.replace('.', '');

  if (!CPFValidator.isValid(cpfWithoutMask)) {
    return 'CPF inválido.';
  }

  return true;
};

/**
 * Validate terms acceptance
 *
 * @param {boolean} accepted
 * @return {*}  {(string | boolean)}
 */
export const termsValidator = (accepted: boolean): string | boolean => {
  if (!accepted) {
    return 'Você precisa aceitar os termos';
  }

  return true;
};

/**
 * Validate Credit Card expires date
 *
 * @param {string} value
 * @return {*}  {(string | boolean)}
 */
export const creditCardExpiresValidator = (value: string): string | boolean => {
  const invalidMessage = 'Data de Expiração inválida';

  if (!value) {
    return invalidMessage;
  }

  const parsedValue = unmaskNumber(value);

  try {
    const month = Number(parsedValue.substring(0, 2));
    const year = Number(parsedValue.substring(2, 6));

    const date = parse(`${month} ${year}`, 'MM yyyy', new Date());

    const valid = isValid(date) && !isBefore(date, startOfMonth(new Date()));

    if (!valid) {
      return invalidMessage;
    }

    return true;
  } catch (reason) {
    return invalidMessage;
  }
};
